import React from 'react';
import {PersonalBox} from "../personal-box/Personal-box";
import {GroupCart} from "./teacher-carts/group-cart/Group-cart";
import {PastClassesCart} from "./teacher-carts/past-classes-cart/Past-classes-cart";
import {NewStudentsCart} from "./teacher-carts/new-students-cart/New-students-cart";
import {TestsCart} from "./teacher-carts/tests-cart/Tests-cart";


export const PersonalCabinetTeacher= () => {

    return (
        <div className="tabs-content">
            <div className="tab">
                <PersonalBox/>
                <div className="info-cards-box">
                    <GroupCart/>
                    <PastClassesCart/>
                    <NewStudentsCart/>
                    <TestsCart/>
                </div>
            </div>
        </div>
    );
};

